import { render } from "./ProductionReceivedReport.vue?vue&type=template&id=fa58aa06&scoped=true"
import script from "./ProductionReceivedReport.vue?vue&type=script&lang=js"
export * from "./ProductionReceivedReport.vue?vue&type=script&lang=js"

import "./ProductionReceivedReport.vue?vue&type=style&index=0&id=fa58aa06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa58aa06"]])

export default __exports__